import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Announcements';

const AnnouncementsApi: any = baseApi(endpoint);

export default AnnouncementsApi;